import React, { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Button, FormControl, Chip, Tabs, Tab } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { IconArrowRight, IconDate } from '../../../icons/Icon';
import MultiSelectNew from '../../../components/MultiSelectNew';
import { DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchGetMenuReportDetails, fetchKitchenReportDetails, fetchKitchenSAPReportDetails, fetchMeals, fetchSites } from '../../../services/varianceReportSlice';
import styles from './filterdata.module.scss';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import { enUS } from 'date-fns/locale';
import SingleSelect from '../../../components/commonComponent/SingleSelect';

const FilterData: React.FC<{ handleClick: () => void, handleFilterChange: () => void, handleParamsChange: any }> = ({ handleClick, handleFilterChange, handleParamsChange }) => {
  const [value, setValue] = useState(0);
  const [expanded, setExpanded] = useState<boolean>(true);
  const dispatch = useDispatch<AppDispatch>();
  const { sites, meals } = useSelector((state: RootState) => state.varianceReport);

  const siteOptions = sites?.length ? sites?.map((site: any) => { return { id: site?.sitecode, label: site?.sitealias, code: site?.sitecode, value: site?.sitecode } }) : [];
  const singlesiteOptions = sites.map((site: any) => ({
    id: site.id,
    label: `${site.sitealias} (${site.sitecode})`,
    value: site.sitecode
  }));
  const mealTimeOptions = meals?.length ? meals?.map((daypart: any) => { return { label: daypart?.name, code: daypart?.daypartcode, ...daypart } }) : [];

  const [selectDate, setSelectDate] = useState<any>(null);
  const [mealTimes, setMealTimes] = useState<string[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const selectedSites = sites.filter(site => selectedOptions.includes(site.siteid)).map(site => ({ id: site.siteid, code: site.sitecode, label: site.sitealias }));
  const selectedMeals = meals.filter(meal => mealTimes.includes(meal.id)).map(meal => ({ label: meal?.name, code: meal?.daypartcode, ...meal }));

  const userId = localStorage.getItem('userid');
  const allSite = sites?.length ? sites?.map((site: any) => site?.sitecode) : [];
  const allMealTime = meals?.length ? meals?.map((daypart: any) => daypart?.daypartcode) : [];
  // Datepicker settings
  const customEnLocale: Locale = {
    ...enUS,
    options: {
      ...enUS.options,
      weekStartsOn: 1,
    },
  };
  useEffect(() => {
    if (userId) {
      dispatch(fetchSites({ userid: userId })).unwrap()?.then((res) => {
        if (res?.length == 1) {
          const initialOptions = res?.map((site: any) => site?.sitecode);
          setSelectedOptions(initialOptions);
        }
      })?.catch((error) => console.error('fetch Sites Variance Report', error));
      dispatch(fetchMeals({ userid: userId, siteidlist: [] })).unwrap()?.then((res) => {
        if (res?.length == 1) {
          const initialOptions = res?.map((meal: any) => meal?.daypartcode);
          setMealTimes(initialOptions);
        }
      })?.catch((error) => console.error('fetch Sites Variance Report', error));
    }
  }, [userId, dispatch]);

  const handleChange = (value: any, type: String) => {
    switch (type) {
      case 'FromDate':
        setSelectDate(value);
        break;
      case 'SiteOption':
        if (location.pathname === '/menuprojectionvsmenurequisitionreport') {
          setSelectedOptions(value);  // For multi-select, just set the value directly
        } else {
          setSelectedOptions(Array.isArray(value) ? value : [value]); // For single select, ensure it's always an array
        }
        break;
      case 'MealOption':
        setMealTimes(value);
        break;
    }
    handleFilterChange();
  };

  const handleSubmit = () => {
    const menupayload = {
      plandate: format(new Date(selectDate), "yyyy-MM-dd'T'00:00:00XXX"),
      sitecodelist: selectedOptions.length === 0 ? allSite : selectedOptions,
      daypartcodelist: mealTimes?.length === 0 ? allMealTime : mealTimes,
    };
    const kitchenpayload = {
      userid: userId,
      plandate: format(new Date(selectDate), "yyyy-MM-dd'T'00:00:00XXX"),
      sitecode: selectedSites?.[0]?.code,
      daypartcodelist: mealTimes?.length === 0 ? allMealTime : mealTimes,
    };
    if (location.pathname === '/menuprojectionvsmenurequisitionreport') {
      dispatch(fetchGetMenuReportDetails(menupayload));
      handleParamsChange(menupayload);
    }
    if (location.pathname === '/projectedkitchenindentvskitchenindentreport') {
      dispatch(fetchKitchenReportDetails(kitchenpayload));
      handleParamsChange(kitchenpayload);
    }
    if (location.pathname === '/kitchenindentvsactualindentreport') {
      dispatch(fetchKitchenSAPReportDetails(kitchenpayload));
      handleParamsChange(kitchenpayload);
    }
    handleClick();
    handleToggleChange();
  };

  const handleToggleChange = () => {
    setExpanded(!expanded);
  };
  return (
    <div className='white-box mb-12'>
      <div className={`flex justify-content-between align-items-center ${expanded ? styles.tabbingDataWrap : styles.tabbingDataWrapMinimize}`}>
        {expanded ? (
          <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="Tabs" className={!expanded ? 'tabs-wrapper colapsed' : 'tabs-wrapper'}>
            <Tab label="Filter" id={`simple-tabpanel-${0}`} aria-labelledby={`simple-tab-${0}`} disableRipple />
          </Tabs>
        ) : (
          <div className='flex align-items-center'>
            <div className={styles.dateRange}>
              <span className={styles.dateLabel}>Date:</span>
              <span className={styles.date}>{selectDate ? format(selectDate, 'dd MMM yyyy') : ''}</span>
            </div>
            {location.pathname === '/menuprojectionvsmenurequisitionreport' ?
              <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
                <span className={styles.dateLabel}>Site:</span>
                <span className={styles.chipData}>
                  {selectedSites?.length === 0 || selectedSites.length === siteOptions.length ? (
                    <Chip label='All Sites' className={styles.chip} />
                  ) : (
                    selectedSites?.map((site: any) => (
                      <Chip key={site.id} label={`${site.label} (${site.code})`} className={styles.chip} />
                    ))
                  )}
                </span>
              </div>
              :
              <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
                <span className={styles.dateLabel}>Site:</span>
                <span className={styles.chipData}>
                  {selectedSites?.map((site: any) => (
                    <span key={site.id} className={styles.chip}>{`${site.label} (${site.code})`}</span>
                  ))}
                </span>
              </div>
            }
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Mealtime:</span>
              <span className={styles.chipData}>
                {selectedMeals?.length === 0 || selectedMeals?.length === mealTimeOptions.length ? (
                  <Chip label='All' className={styles.chip} />
                ) : (
                  selectedMeals?.map((meal: any) => (
                    <Chip key={meal.code} label={meal.label} className={styles.chip} />
                  ))
                )}
              </span>
            </div>
          </div>
        )}
        <Button onClick={() => handleToggleChange()} className={`expend-btn ${expanded && 'active'}`} disableRipple>
          {expanded ? 'Minimize Section' : 'Expand'}
          <span><ExpandMore /></span>
        </Button>
      </div>
      <div className={`inner-contant ${!expanded && 'd-none'}`}>
        <CustomTabPanel value={0} index={0}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
            <FormControl fullWidth>
              <div className="flex justify-content-between align-items-end">
                <div className={`${styles.leftBox} flex align-items-end`}>
                  <div className={`date-wrap flex flex-column mr-24 ${styles.multiSelect}`}>
                    <label className={`${styles.label}`}>Select Date <span>*</span></label>
                    <DatePicker
                      value={selectDate}
                      onChange={(newValue) => handleChange(newValue, "FromDate")}
                      slotProps={{ field: { clearable: true } }}
                      format='dd MMM yyyy'
                      slots={{ openPickerIcon: IconDate }}
                      label="Select Date"
                    />
                  </div>
                  {location.pathname === '/menuprojectionvsmenurequisitionreport' ?
                    <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
                      <MultiSelectNew
                        options={siteOptions}
                        label='Select Site'
                        disabled={siteOptions?.length == 1}
                        selectedValues={selectedOptions}
                        onApply={(e) => handleChange(e, "SiteOption")}
                        placeholder='Select Site'
                        selectAllLabel='All Site'
                      />
                    </div>
                    :
                    <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
                      <SingleSelect
                        label="Select Site"
                        options={singlesiteOptions}
                        value={selectedOptions[0] || ''}
                        onChange={(e) => handleChange(e.target.value, 'SiteOption')}
                        placeholder='Select Site'
                        disabled={siteOptions?.length == 1}
                      />
                    </div>
                  }
                  <div className={`flex flex-column ${styles.multiSelect}`}>
                    <MultiSelectNew
                      options={mealTimeOptions}
                      label='Select Mealtime'
                      disabled={siteOptions?.length == 0 || mealTimeOptions?.length == 1}
                      selectedValues={mealTimes}
                      onApply={(e) => handleChange(e, "MealOption")}
                      showLabelOnly={true}
                      placeholder='Select Mealtime'
                      selectAllLabel='All Meals'
                    />
                  </div>
                </div>
                <Button
                  onClick={handleSubmit}
                  className={`primary-btn ${styles.primaryBtn}`}
                  disabled={!selectDate || (location.pathname !== '/menuprojectionvsmenurequisitionreport' && !selectedOptions.length)}
                >
                  Go <IconArrowRight />
                </Button>
              </div>
            </FormControl>
          </LocalizationProvider>
        </CustomTabPanel>
      </div>
    </div>
  );
};

export default FilterData;
